import parsePhoneNumber from 'libphonenumber-js'

export const validatePhone = (number: any) => {
    let check = parsePhoneNumber(number);
    if (check && check.isValid()) {
        return true;
    }
    else {
        // console.log("Phone Number Invalid")
        // alert('Phone Number Invalid')
        return false;
    }
}
